import React from 'react';
import './ExportButton.scss';

interface ExportButtonProps {
  /** Function to handle export action */
  onExport: () => void;
  /** Custom class name */
  className?: string;
  /** Whether button is disabled */
  disabled?: boolean;
  /** Number of selected items */
  selectedItemsCount?: number;
  /** Custom label */
  label?: string;
}

/**
 * Generic Export button component
 * Shows different text based on selection state
 */
const ExportButton: React.FC<ExportButtonProps> = ({
  onExport,
  className = '',
  disabled = false,
  selectedItemsCount = 0,
  label
}) => {
  const buttonLabel = label || (selectedItemsCount > 0 ? 'Export Selected as Excel' : 'Export All as Excel');

  return (
    <button
      className={`export-button ${className}`}
      onClick={onExport}
      disabled={disabled}
      type="button"
    >
      {buttonLabel}
    </button>
  );
};

export default ExportButton;
